import { render, staticRenderFns } from "./WorkTaskKanbanColumn.vue?vue&type=template&id=1f6a14a4&scoped=true"
import script from "./WorkTaskKanbanColumn.vue?vue&type=script&lang=ts"
export * from "./WorkTaskKanbanColumn.vue?vue&type=script&lang=ts"
import style0 from "./WorkTaskKanbanColumn.vue?vue&type=style&index=0&id=1f6a14a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6a14a4",
  null
  
)

export default component.exports